import React, { useEffect, useMemo, useRef } from 'react';
import { List, useSafeArea } from '@banhala/ui-kit';
import { useLogDisplayCarousel } from '../hooks/useLogDisplayCarousel';
import { useCartAddRecommend } from '../../BottomDocked/queries/useCartAddRecommend';
import { GoodsCarouselItem } from './GoodsCarouselItem';
import { GoodsRecommendSkeleton } from './GoodsRecommendSkeleton';

type AddCartRecommendProps = {
  isExpanded: boolean;
  onContentHeightChange: (size: number) => void;
  onCarouselCountChange?: (count: number) => void;
};

const AddCartRecommendContent: React.FC<AddCartRecommendProps> = props => {
  const { data: addCartRecommend } = useCartAddRecommend();
  const { bottom } = useSafeArea();

  const { onViewableItemsChanged, viewedIndices } = useLogDisplayCarousel();
  const viewabilityConfigRef = useRef({ itemVisiblePercentThreshold: 80 });

  const carousels = useMemo(
    () => addCartRecommend?.carousels ?? [],
    [addCartRecommend?.carousels],
  );

  const onCarouselCountChange = props.onCarouselCountChange;
  useEffect(() => {
    onCarouselCountChange?.(carousels.length);
  }, [carousels.length, onCarouselCountChange]);

  return (
    <List
      style={{ flex: 1 }}
      data={carousels}
      onContentSizeChange={(_, contentHeight) => {
        props.onContentHeightChange(contentHeight);
      }}
      contentContainerStyle={{
        paddingBottom: bottom,
      }}
      scrollEnabled={props.isExpanded}
      onViewableItemsChanged={onViewableItemsChanged}
      viewabilityConfig={viewabilityConfigRef.current}
      renderItem={({ item: carousel, index }) => {
        return (
          <GoodsCarouselItem
            carousel={carousel}
            isLogEnabled={viewedIndices.has(index)}
          />
        );
      }}
    />
  );
};

export const AddCartRecommend: React.FC<AddCartRecommendProps> = props => {
  return (
    <React.Suspense fallback={<GoodsRecommendSkeleton />}>
      <AddCartRecommendContent {...props} />
    </React.Suspense>
  );
};
